import React, { useState } from "react";
import "../css-coding/ProcessSection.css";


// const steps = [
//   {
//     id: "01",
//     title: "Strategy & Research",
//     desc: "We begin by deeply understanding your business, audience, and goals. From niche to narrative, we craft a strategy that aligns with your brand vision and market needs",
//   },
//   {
//     id: "02",
//     title: "Content Design & Planning",
//     desc: "We conceptualize content ideas, create prototypes, and plan shoots or edits that blend storytelling with design thinking, all tailored to your unique brand voice.",
//   },
//   {
//     id: "03",
//     title: "Production & Editing",
//     desc: "Our expert team brings the vision to life through high-quality shoots, reels, video editing, and design assets, optimized for performance across Instagram YouTube, and beyond.",
//   },
//   {
//     id: "04",
//     title: "Launch, Manage & Grow",
//     desc: "We schedule, publish, and manage your content, while tracking results engaging your audience, and continuously optimizing for better reach and revenue",
//   },
// ];

// const ProcessSections = () => {
//   const [active, setActive] = useState(0);

//   return (
//     <section className="process-section">
//       <div className="process-header">
//         <p className="process-label">/OUR PROCESS/</p>
//         <h2 className="process-heading">
//           We help brands grow through creative content, personal branding, and
//           performance first storytelling, built with consistency, creativity,
//           and community at the core.
//         </h2>
//       </div>

//       <div className="process-cards">
//         {steps.map((step, index) => (
//           <div
//             key={index}
//             className={`process-card ${active === index ? "active" : ""}`}
//             onMouseEnter={() => setActive(index)}
//           >
//             <p className="step-id">{step.id}</p>
//             <h3 className="step-title">{step.title}</h3>

//             <div className={`step-desc ${active === index ? "is-visible" : "is-hidden"}`}>
//               {step.desc}
//             </div>
//           </div>
//         ))}
//       </div>
//     </section>
//   );
// };

// export default ProcessSections;

const steps = [
  {
    id: "01",
    title: "Strategy & Research",
    desc: "We begin by deeply understanding your business, audience, and goals. From niche to narrative, we craft a strategy that aligns with your brand vision and market needs",
  },
  {
    id: "02",
    title: "Content Design & Planning",
    desc: "We conceptualize content ideas, create prototypes, and plan shoots or edits that blend storytelling with design thinking, all tailored to your unique brand voice.",
  },
  {
    id: "03",
    title: "Production & Editing",
    desc: "Our expert team brings the vision to life through high-quality shoots, reels, video editing, and design assets, optimized for performance across Instagram YouTube, and beyond.",
  },
  {
    id: "04",
    title: "Launch, Manage & Grow",
    desc: "We schedule, publish, and manage your content, while tracking results engaging your audience, and continuously optimizing for better reach and revenue",
  },
];

const ProcessSections = () => {
  const [active, setActive] = useState(null);

  return (
    <section className="process-section">
      <div className="process-header">
        <p className="process-label">/OUR PROCESS/</p>
        <h2 className="process-heading">
          We help brands grow through creative content, personal branding, and
          performance first storytelling, built with consistency, creativity,
          and community at the core.
        </h2>
      </div>

      <div className="process-cards">
        {steps.map((step, index) => (
          <div
            key={index}
            className={`process-card ${active === index ? "active" : ""}`}
           onMouseEnter={() => window.innerWidth > 1180 && setActive(index)}
           onClick={() => setActive(active === index ? null : index)}
          >
            <p className="step-id">{step.id}</p>
            <h3 className="step-title">{step.title}</h3>

            <div className={`step-desc ${active === index ? "is-visible" : "is-hidden"}`}>
              {step.desc}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ProcessSections;